import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CashPosition } from '../../models/cash-position.model';

export const CashPositionsActions = createActionGroup({
  source: 'CashPositions',
  events: {
    'Load Cash Positions': emptyProps(),
    'Load Cash Positions Success': props<{ positions: CashPosition[] }>(),
    'Load Cash Positions Failure': props<{ error: string }>(),
  }
});
